// Backend media URLs are normally absolute (signed GCS links) and load
// straight into <img>/<iframe>. In local dev (no GCS configured) the backend
// falls back to a relative streaming route — see `resolveMediaUrl` in
// privateMessageService.js / chatGroupService.js — which needs the API
// origin prefixed and the user's token attached as a query param, since plain
// <img>/<iframe> tags can't send an Authorization header. The auth middleware
// only accepts `?token=` on paths containing `/preview/` or `/download/`.
const API_BASE_URL = process.env.REACT_APP_BASE_URL || 'https://nexploy-eg.com';

export const resolveMediaSrc = (url) => {
  if (!url || typeof url !== 'string') return url;
  if (!url.startsWith('/api/')) return url; // already absolute, or a data: URI

  const token = localStorage.getItem('token');
  const separator = url.includes('?') ? '&' : '?';
  return `${API_BASE_URL}${url}${token ? `${separator}token=${encodeURIComponent(token)}` : ''}`;
};

export default resolveMediaSrc;
